/**
 * Gets the value from the given path through a data structure
 * @param {object} context
 * @param {...string|number} path
 * @return {*}
 *
 * @example
 * var context = { response: { data: { foo: 123 } } };
 * const value = getIn(context, 'response', 'data', 'foo');
 */
export const getValueIn = (context, ...path) => {
    let value = context;
    while (value !== undefined && value !== null && path.length) {
        value = value[path.shift()];
    }
    return value;
};

export const safeGetValueIn = (context, ...path) => {
    try {
        return getValueIn(context, ...path);
    } catch (e) {
        return null;
    }
};

export const localeLanguageCode = locale => {
    const matches = locale.match(/^[^-_]*/, locale);
    return matches.length ? matches[0] : locale;
};
